// import axios from 'axios';
// import axios from './_axios';
import axios from 'axios';
import getAccesstokenNameByRoute from './getAccesstokenNameByRoute';
import { refreshAccessToken, isRefreshableAuthError, isPublicAuthExemptEndpoint } from './tokenRefresh';
import commonLogout, { isAccountChangedElsewhere } from '../common-logout';
import { getTenantKey } from '../tenant-context';

export default function createInstance (path, options = {}) {
    const _baseURL = !path
        ? `${process.env.VUE_APP_BACKENDHOST}`
        : `${process.env.VUE_APP_BACKENDHOST}/${path}`

    const _instance = axios.create({
        baseURL: _baseURL,
        headers: {
            "Cache-Control": "no-cache, no-store, must-revalidate",
            "Pragma": "no-cache",
            "Expires": '0'
        },
        ...options
    })

    _instance.interceptors.request.use(
        function (config) {
            // 다른 탭에서 계정이 바뀌었으면 이 탭(이전 계정 화면)의 쓰기 요청을 보내지 않는다 — App.vue 가 안내한다
            if (isAccountChangedElsewhere(config)) {
                if (window.EventBus) window.EventBus.$emit('account-changed-elsewhere');
                return Promise.reject(Object.assign(new Error('account changed in another tab'), { code: 'ACCOUNT_CHANGED' }));
            }
            const _accesstoken_name = getAccesstokenNameByRoute()

            // Do something before request is sent
            if (process.env.VUE_APP_BUILD_ENV !== 'production') {
                console.log(` ~~~~~~~~~~~~ - _instance interceptors - (request) - (test & develop log) ~~~ `);
                console.log(` ~~~~~~~~~~~~ - request - (config) ~~~ `);
                console.log(` ~ config => `, config);

                console.log(` ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ `);
            }
            
            config.headers['Authorization'] = `Bearer ${localStorage.getItem(_accesstoken_name)}`;
            // 테넌트 힌트 헤더 — env(로컬 개발 override) 우선, 없으면 hostname 판정 키 (_axios.js 와 동일 규칙)
            const _subdomain = process.env.VUE_APP_SUBDOMAIN || getTenantKey();
            if (_subdomain) {
                config.headers['X-Subdomain'] = _subdomain;
            }
            return config;
        },
        function (error) {
            // Do something with request error
            console.log(` ~~~~~~~~~~~~ - _instance interceptors - (request) - (test & develop log) ~~~ `);
            console.log(` ~~~~~~~~~~~~ - request - (error) ~~~ `);
            console.log(` ~ error => `, error);
            console.log(` ~ localStorage.getItem('accesstoken') => `, localStorage.getItem('accesstoken'));
            console.log(` ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ `);
            return Promise.reject(error);
        }
    );
      
    // Add a response interceptor
    _instance.interceptors.response.use(
        function (response) {
            // // Do something with response data
            // console.log(` ~~~~~~~~~~~~ - _instance interceptors - (response) - (test & develop log) ~~~ `);
            // console.log(` ~~~~~~~~~~~~ - response - (response) ~~~ `);
            // console.log(` ~ response => `, response);
            // console.log(` ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ `);
            return response;
        },
        async function (error) {
            // Do something with response error
            if (process.env.VUE_APP_BUILD_ENV !== 'production') {
                console.log(` ~~~~~~~~~~~~ - _instance response - (test & develop log) ~~~ `);
                console.log(` ~~~~~~~~~~~~ - response - (error) ~~~ `);
                console.log(` ~ error => `, error);
                console.log(` ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ `);
            }

            if (error.response && error.response.status === 401) {
                // JWT 점진 채택: access(JWT) 만료 시 refresh 쿠키로 새 access 를 재발급받아
                // 원 요청을 재시도한다. 공유 헬퍼(refreshAccessToken)가 동시 401 을 dedup 한다
                // (thundering herd 방지). refresh/login 자체·이미 재시도한 요청은 아래 로그아웃 폴백.
                const _originalRequest = error.config || {};
                if (isRefreshableAuthError(_originalRequest)) {
                    _originalRequest._retriedWithRefresh = true;
                    try {
                        const _newToken = await refreshAccessToken();
                        _originalRequest.headers = _originalRequest.headers || {};
                        _originalRequest.headers['Authorization'] = `Bearer ${_newToken}`;
                        return _instance(_originalRequest);
                    } catch (_refreshError) {
                        // refresh 실패 → 아래 로그아웃 폴백
                        if (process.env.VUE_APP_BUILD_ENV !== 'production') {
                            console.log(` ~ JWT refresh 실패 → logout 폴백 => `, _refreshError);
                        }
                    }
                }

                // public(비인증) 승인 엔드포인트의 401 은 로그인 세션 문제가 아니라 승인 토큰
                // 자체의 무효/만료이므로, 글로벌 로그아웃/홈 리다이렉트를 건너뛰고 원 에러를
                // 컴포넌트로 전파한다(RegAuth 화면 안내문이 표시되도록).
                if (!isPublicAuthExemptEndpoint(_originalRequest)) {
                    commonLogout()
                }
            }

            return Promise.reject(error);
        }
    );
    return _instance
}

